import { useState } from "react";
import CloseIcon from "../../../assets/hospitalCloseIcon.svg";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
const OutTimeModal = ({
  setOpen,
  selectedCase,
  AllCases,
  setOpenEnhancement,
  setOpenDischarge,
  handleInitiateEnhancement,
}) => {
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");
  const [saving, setSaving] = useState(false);
  const [isSaved, setSaved] = useState(false);
  const convertToTZ = (value) => {
    if (!value) return "";
    return new Date(value).toISOString();
  };

  const getMinOutTime = (inTime) => {
    if (!inTime) return "";

    const date = new Date(inTime);
    date.setHours(date.getHours() + 3);

    const pad = (n) => String(n).padStart(2, "0");

    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes())
    );
  };

  const handleInTimeChange = (value) => {
    setInTime(value);

    const minOut = getMinOutTime(value);

    if (outTime && outTime < minOut) {
      setOutTime("");
    }
  };

  const isValid = inTime && outTime && outTime >= getMinOutTime(inTime);

  const handleSave = async () => {
    const postStageData = {
      commandCeneterStage: selectedCase?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("admission")
        ? "Admission Dialysis on Out"
        : "Enhancement Dialysis on Out",
      dialysisInTime: new Date().toISOString(),
      dialysisOutTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    };

    try {
      const res = await CaseServices.updateSubMasterStage(
        selectedCase.id,
        postStageData,
      );
      toast.success(res?.data?.message);
      await AllCases();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center z-[1201] bg-[#017C7180]">
      <div className="relative h-fit w-[50%] bg-white p-[30px] rounded-[30px]">
        <div
          className="absolute top-2 right-2 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>

        <div className="text-[42px] text-black -tracking-[4px] text-center">
          Initiate Dialysis Out
        </div>

        <div className="border border-solid border-[#E8E8E8] my-4" />

        <div className="flex justify-between items-end">
          <div className="flex items-center justify-center gap-[60px]">
            <div>
              <div className="text-sm mb-1">IN Time</div>
              <input
                type="datetime-local"
                value={inTime}
                className="border-[0.5px] border-[#017C71] p-4 rounded-full"
                onChange={(e) => handleInTimeChange(e.target.value)}
              />
            </div>

            <div>
              <div className="text-sm mb-1">OUT Time</div>
              <input
                type="datetime-local"
                value={outTime}
                min={getMinOutTime(inTime)}
                className="border-[0.5px] border-[#017C71] p-4 rounded-full"
                onChange={(e) => setOutTime(e.target.value)}
              />
            </div>
          </div>

          {saving ? (
            <CircularProgress />
          ) : (
            <div
              className={`text-xs text-white font-medium px-[58px] py-4 rounded-full ${
                isValid
                  ? "bg-[#017C71] cursor-pointer"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
              onClick={() => {
                if (!isValid) return;
                handleSave();
              }}
            >
              Save
            </div>
          )}
        </div>

        {isSaved && (
          <div className="flex justify-center items-center gap-[30px] mt-6">
            <div
              className="text-xs font-medium text-white -tracking-[0.07em] bg-[#017C71] px-[55.5px] py-4 rounded-full cursor-pointer"
              onClick={() => {
                // setOpenEnhancement(true);
                handleInitiateEnhancement(selectedCase);
                setOpen(false);
              }}
            >
              Initiate Enhancement
            </div>
            <div
              className="text-xs font-medium text-white -tracking-[0.07em] bg-[#017C71] px-[55.5px] py-4 rounded-full cursor-pointer"
              onClick={() => {
                setOpenDischarge(true);
                setOpen(false);
              }}
            >
              Initiate Discharge{" "}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OutTimeModal;
